import * as googleAuthApi from '../services/api/googleAuth';

export const REFRESH_QR_CODE_GENERATED = 'REFRESH_QR_CODE_GENERATED';
export const QR_CODE_GENERATING = 'QR_CODE_GENERATING';
export const QR_CODE_GENERATE_ERROR = 'QR_CODE_GENERATE_ERROR';
export const RESET_QR_CODE = 'RESET_QR_CODE';
export const GOOGLE_OTP_VERIFIED = 'GOOGLE_OTP_VERIFIED';
export const SET_GOOGLE_AUTH_ERRORS = 'SET_GOOGLE_AUTH_ERRORS';
export const CLEAR_GOOGLE_AUTH_ERRORS = 'CLEAR_GOOGLE_AUTH_ERRORS';

export function generateAppQrCode(userId) {
    return dispatch => {

        const success = (res) => {
            dispatch(qrCodeGenerated(res))
            dispatch(qrCodeGenerating(false));
        }

        const failure = (res) => {
            dispatch(qrCodeGenerateError());
            dispatch(qrCodeGenerating(false));
        }

        dispatch(qrCodeGenerating(true));

        return googleAuthApi
            .generateAppQRCode(userId)
            .then(success, failure);
    }
}

export function confirmSetup(code) {
    return dispatch => {

        const success = (res) => {
            dispatch(otpVerified(res.payload))
        }

        const failure = (res) => {
            if (res.errors) {
                dispatch(setErrors(res.errors));
            } else {
                dispatch(setErrors(res.payload));
            }
        }

        dispatch(clearErrors());

        const params = {
            verify_code: code
        }

        return googleAuthApi
            .confirmSetup(params)
            .then(success, failure);
    }
}

export function qrCodeGenerated(qrCodeData) {
    return {
        type: REFRESH_QR_CODE_GENERATED,
        qrCodeData
    }
}

export function qrCodeGenerateError() {
    return {
        type: QR_CODE_GENERATE_ERROR
    }
}

export function qrCodeGenerating(isGenerating) {
    return {
        type: QR_CODE_GENERATING,
        isGenerating
    }
}

export function resetQrCode() {
    return {
        type: RESET_QR_CODE
    }
}

export function otpVerified(verified) {
    return {
        type: GOOGLE_OTP_VERIFIED,
        verified
    }
}

export function setErrors(errors) {
    return {
        type: SET_GOOGLE_AUTH_ERRORS,
        errors
    }
}

export function clearErrors() {
    return {
        type: CLEAR_GOOGLE_AUTH_ERRORS
    }
}